/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import React from 'react';
import tw, { styled } from 'twin.macro';
import { useSelector } from 'react-redux';
import { UiIndicator } from '../../../form_fields/common-field-styles';
import { selectFormDesign } from '../../selectors';

const PaymentForm = ({
  closeModal,
  handleOpenModal,
  openModal,
  gateway,
  ctrl,
  startPayment,
  handleChange,
  paymentDetails,
  message,
  finalAmount,
}) => {
  const { phone, email, amount } = paymentDetails;
  const formDesign = useSelector((state) => selectFormDesign(state));
  const invalidAmount = (finalAmount ?? amount) <= 0;
  const invalidAmountMsg = `An error occurred. Please, add an amount before proceeding with payment`;

  return (
    <Modal closeIcon onClose={closeModal} onOpen={handleOpenModal} open={openModal} size="small">
      <FormContainer
        style={{
          '--font-family': formDesign.old.form_font,
        }}>
        <Header>Enter your details</Header>
        <Form onSubmit={startPayment}>
          {message && (
            <UiIndicator className="status red">
              <span>{message}</span>
            </UiIndicator>
          )}

          <Fields>
            <Field>
              <label htmlFor={`${ctrl.internal_id}-${gateway}-email`}>Email: </label>
              <input
                type="email"
                value={email}
                placeholder="johndoe@samplemail.com"
                id={`${ctrl.internal_id}-${gateway}-email`}
                onChange={(e) => handleChange('email', e.target.value)}
                required
              />
            </Field>
            <Field>
              <label htmlFor={`${ctrl.internal_id}-${gateway}-phone`}>Phone Number: </label>
              <input
                type="tel"
                value={phone}
                placeholder="00 000 0000000"
                id={`${ctrl.internal_id}-${gateway}-phone`}
                onChange={(e) => handleChange('phone', e.target.value)}
                required
              />
            </Field>

            {ctrl.props.user_specify && (
              <Field>
                <label htmlFor={`${ctrl.internal_id}-${gateway}-amount`}>Amount in {ctrl.props.currency}: </label>
                <input
                  type="number"
                  step="0.01"
                  value={amount}
                  id={`${ctrl.internal_id}-${gateway}-amount`}
                  onChange={(e) => handleChange('amount', e.target.value)}
                />
              </Field>
            )}
          </Fields>

          <Actions>
            <button type="button" id="cancel" onClick={closeModal}>
              Cancel
            </button>
            <button type="submit" id="continue" disabled={invalidAmount}>
              Continue
            </button>
          </Actions>
          {invalidAmount && <AmountError>{invalidAmountMsg}</AmountError>}
        </Form>
      </FormContainer>
    </Modal>
  );
};
PaymentForm.defaultProps = {
  message: '',
};
PaymentForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  startPayment: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired,
  gateway: PropTypes.string.isRequired,
  message: PropTypes.string,
  finalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  ctrl: PropTypes.shape({
    internal_id: PropTypes.string.isRequired,
    props: PropTypes.shape({
      currency: PropTypes.string.isRequired,
      user_specify: PropTypes.bool.isRequired,
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  }).isRequired,
  paymentDetails: PropTypes.shape({
    email: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};
export default PaymentForm;

const FormContainer = styled.div``;

const Form = styled.form`
  padding: 30px;
`;

const Header = styled.header`
  text-align: center;
  padding: 35px 10px;
  font-size: 20px;
  font-weight: 600;
  font-family: var(--font-family) !important;
  background: linear-gradient(270deg, #00afbf, #1a8caf);
  color: white;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
`;

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin: 20px 0 40px 0;
`;

const Field = styled.div`
  > label {
    display: block;
    font-size: 16px;
    font-weight: 500;
    font-family: var(--font-family) !important;
    margin-bottom: 10px;
    color: #444;
  }

  > input {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 15px;
    font-family: var(--font-family) !important;

    &:focus {
      outline: none;
      border-color: #85b7d9;
    }

    ::placeholder {
      color: #ccc !important;
    }
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;

  > button {
    font-size: 16px;
    font-weight: 500;
    font-family: var(--font-family) !important;
    cursor: pointer;
    padding: 7px 15px;
    background-color: transparent;
    border: 0.8px solid;
    border-radius: 3px;
    transition: 200ms;

    @media screen and (min-width: 768px) {
      padding: 7px 30px;
    }

    &#cancel {
      border-color: red;
      color: red;

      :hover {
        background-color: red;
        color: white;
      }
    }

    &#continue {
      background-color: #00afbf;
      border-color: #00afbf;
      color: white;

      :hover {
        background-color: #1a8caf;
        border-color: #1a8caf;
      }

      :disabled {
        background-color: #ddd;
        border-color: #ddd;
        cursor: not-allowed;
      }
    }
  }
`;

const AmountError = styled.span`
  display: block;
  color: red;
  font-size: 13px;
  font-family: var(--font-family) !important;
  margin-top: 20px;
`;
